import { BasicComponentProps } from '@whoop/web-components';
import React, { ReactNode } from 'react';
import styles from './index.module.scss';

// Icon from @whoop/web-components (via MHTML source)
const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor" width="16" height="16">
    <path d="M15 12c1.7 0 3 1.3 3 3v12c0 1.7-1.3 3-3 3s-3-1.3-3-3V15c0-1.7 1.3-3 3-3zm-3-9c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3z" />
  </svg>
);

// Placeholder for an Error icon (e.g., exclamation mark)
const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8.28 4.95a.75.75 0 01-1.06-1.06L9.94 12.6l-1.27-1.27a.75.75 0 011.06-1.06L11 11.54l1.27-1.27a.75.75 0 111.06 1.06L12.06 12.6l1.27 1.27a.75.75 0 11-1.06 1.06L11 13.66l-1.28 1.29z" clipRule="evenodd" />
  </svg>
);

type DescriptionProps = {
  label?: ReactNode;
  type?: 'info' | 'error'; // Added 'error' to type prop
} & BasicComponentProps;

function Description({ label, children, type, ...props }: DescriptionProps) {
  const rootClasses = [
    styles.root,
    type === 'info' ? styles.infoBox : '',
    type === 'error' ? styles.errorBox : '',
  ].join(' ').trim();

  const iconToRender = () => {
    if (type === 'info') {
      return (
        <div className={styles.iconWrapper}> 
          <InfoIcon />
        </div>
      );
    }
    if (type === 'error') {
      return (
        <div className={styles.iconWrapper}> 
          <ErrorIcon />
        </div>
      );
    }
    return null;
  };

  return (
    <div className={rootClasses} {...props}> {/* data-testid will be applied here */}
      {iconToRender()}
      {label && !type && <div className={styles.label}>{label}</div>} 
      <div className={type ? styles.typedBody : styles.body}>{children}</div>
    </div>
  );
}

export default Description;
